/**
 * EL STUDIO COMO FLUJO (3-oct-2026).
 *
 * Rais: «hay que hacerlo más sencillo… un workflow con human in the loop, sin los colaboradores
 * editoriales, porque lo que quiere la gente es editar el manuscrito y no estar conversando con
 * gente». El Studio nuevo son cinco fases que se aprueban una a una y un solo interlocutor, el
 * coach, a la derecha. Se construye dentro del mismo Studio, tras un interruptor (`?flujo=1`), y se
 * cambia para todos cuando el flujo funcione de Diagnóstico a Pasadas.
 *
 * Este contexto es ese interruptor, para que cada pieza lo lea sin pasarlo de mano en mano. Qué
 * vale el interruptor lo decide `flujoActivo` en logica.ts, que es lo que se prueba.
 */
import { createContext, useContext } from "react";

export const Flujo = createContext(false);
export const useFlujo = (): boolean => useContext(Flujo);
